import { useState } from "react";
import Footer from "../components/Footer";
import Scrolltop from "../components/Scrolltop";
import Header from "../components/Header";
import "react-modal-video/css/modal-video.min.css";
import Sidebar from "../components/Navbar/Sidebar";
import CareerNovomatic from "../components/About/CareerNovomatic";

const Career = () => {
  const [isSidebarOpened, setIsSidebarOpened] = useState(null);

  return (
    <>
      <Header setIsSidebarOpened={setIsSidebarOpened}/>
      <div className="career_page">
        <CareerNovomatic />
        <Sidebar 
            isSidebarOpened={isSidebarOpened}
            setIsSidebarOpened={setIsSidebarOpened}
          />
        <Footer />
        <Scrolltop />
      </div>
    </>
  );
};

export default Career;
